module.exports = __webpack_public_path__ + "static/docsFrontMobile@2x-1f3741f0c859e51cfcfd97fe2c5c371b.png";